import React, { Fragment } from 'react';
import FocusLock from 'react-focus-lock';

const ImpersonateFocusWrapper = ({ children, isPlayerRoute }) => {
  if (isPlayerRoute) {
    return (
      <FocusLock group="student-player-group" autoFocus={false}>
        {children}
      </FocusLock>
    );
  }

  return <Fragment>{children}</Fragment>;
};

export default ImpersonateFocusWrapper;
